import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageLayout } from '../../PageLayout';
import { PageCard } from '../../Compounds/CardWithTitle';
import {
  GridPreferences,
  getDefaultPreferences,
  getPreferencesByKey,
  getUserPreferencesSubject
} from '../../../store/User';
import { UpstackDataGrid } from '../../Compounds/UpstackDataGrid/UpstackDataGrid';
import { DefaultPhoneNumberGridColumnDefs } from './PhoneNumberGridColumnDefs';
import { GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { getGridColumns } from '../../Compounds/UpstackDataGrid/helpers';
import { EntityVoiceDetailsRecord } from '../../../types';
import { getInventoryLoadingSubject, getEntityVoiceDetailsSubject } from '../../../store/Inventory';

export const PhoneNumbersPage = () => {
  const [records, setRecords] = useState<EntityVoiceDetailsRecord[]>([]);
  const page = 'Phone Numbers';
  const nameGrid = 'phone_number_grid';
  const [recordsLoading, setRecordsLoading] = useState<boolean>(true);
  const [orderColumns, setOrderColumns] = useState<GridSingleSelectColDef[]>();
  const [gridSettings, setGridSettings] = useState<GridPreferences>(
    getDefaultPreferences().content[nameGrid] as GridPreferences
  );
  const [search] = useSearchParams();
  const recordId = search.get('recordId') || '';

  useEffect(() => {
    const subscription = getEntityVoiceDetailsSubject().subscribe((records) => {
      const filteredRecords = recordId ? records.filter((record) => record.entityId === recordId) : records;
      setRecords(filteredRecords);
      setOrderColumns(getGridColumns(filteredRecords, DefaultPhoneNumberGridColumnDefs, nameGrid));
    });
    const settingsSub = getUserPreferencesSubject().subscribe(() => {
      const gridPrefs = getPreferencesByKey(nameGrid) as GridPreferences;
      if (gridPrefs) {
        setGridSettings(gridPrefs);
      }
    });
    const loadingSubscription = getInventoryLoadingSubject().subscribe((loading) => setRecordsLoading(loading));

    return () => {
      if (subscription) subscription.unsubscribe();
      if (loadingSubscription) loadingSubscription.unsubscribe();
      if (settingsSub) settingsSub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (records.length) {
      const colsUpdate = getGridColumns(records, DefaultPhoneNumberGridColumnDefs, nameGrid);
      setOrderColumns(colsUpdate);
    }
  }, [records.length]);

  return (
    <PageLayout pageTitle={page}>
      <PageCard
        childrenWrapperClass="min-h-80 max-w-[60vw] min-w-full"
        title={`${page} (${records.length} Item${records.length > 1 ? 's' : ''})`}>
        {orderColumns ? (
          <div className="max-w-full">
            <UpstackDataGrid
              dataCy="phone-numbers-data-grid"
              title="Phone Numbers"
              rows={records}
              columns={orderColumns}
              loadingData={recordsLoading}
              page={nameGrid}
              gridSettings={gridSettings}
              showSearch
            />
          </div>
        ) : (
          <></>
        )}
      </PageCard>
      <div className="h-2"></div>
    </PageLayout>
  );
};
